module.exports = __webpack_public_path__ + "images/marketing/features/google-users.png";